import { baseService } from '@repo/services';
import { normalizedResponseSelector } from '@repo/utils';
import { ApiUtils, CaseUtil } from '@vectord/utils';
import { type ChatMessage } from 'chat/types/message';

export interface LeadChatMessagesResponse {
  messages: ChatMessage[];
  meta: {
    totalCount: number;
    limit: number;
    offset: number;
  };
}

interface GetLeadChatMessagesPayload {
  ransackParams?: {
    by_lead: string;
  };
  extraParams?: {
    limit: number;
    offset: number;
  };
}

interface UploadMediaResponse {
  data: {
    url: string;
  }
}

export const leadChatMessagesService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    getLeadChatMessages: builder.query<LeadChatMessagesResponse, GetLeadChatMessagesPayload>({
      query: ({ ransackParams, extraParams }) => {
        // @ts-ignore - URLSearchParams type accept only string
        const queryParams = new URLSearchParams({
          q: JSON.stringify(ransackParams ?? {}),
          ...extraParams,
        });

        return {
          url: `v1/whatsapp/messages?${queryParams}`,
          method: 'GET',
        };
      },
      transformResponse: (response: any) => {
        const preNormalized = ApiUtils.normalizeJsonApiResponse(response);
        const normalizedResponse = normalizedResponseSelector(preNormalized.data, preNormalized.associations);
        const caseNormalizedResponse = CaseUtil.toCase('camelCase', normalizedResponse);

        return {
          messages: caseNormalizedResponse as ChatMessage[],
          meta: CaseUtil.toCase('camelCase', response?.meta ?? {}),
        };
      },
    }),
    uploadMedia: builder.mutation<UploadMediaResponse, { media: File }>({
      query: ({ media }) => {
        const formData = new FormData();
        formData.append('asset', media);

        return {
          url: 'v1/whatsapp/assets',
          method: 'POST',
          body: formData,
        };
      },
    }),
  }),
});

export const {
  useGetLeadChatMessagesQuery,
  useUploadMediaMutation,
} = leadChatMessagesService;
